import {Injectable} from '@angular/core';
import {ApiService} from './api.service';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Invoice} from "@core/shared/models/invoice";

@Injectable({
    providedIn: 'root'
})
export class CommissionService {

    constructor(
        private _apiService: ApiService,
        private _httpClient: HttpClient,
    ) {}

    public getSocietyItemsInvoiceAPI(societyId: number): Observable<Invoice> {

        const headers: HttpHeaders = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json');

        let url: string = `${this._apiService.getApiUrl(false, true)}/societies/${societyId}/invoices/commissions`;

        return this._httpClient.get<Invoice>(url, {
            headers: headers
        });
    }
}
